module.exports = __webpack_public_path__ + "img/2024big25.0f4bb035.png";